export default __webpack_public_path__ + "media/images/icons/file-invoice-dollar-solid-e70c907eb9f1cd07f21b851f871e2c2b.svg";